const LocalStorageKeysEnum = {
  loginTime: 'login-time',
  xAuth: 'x-auth'
}

export default LocalStorageKeysEnum;
